import { axios } from '@/services/axios';

const getCustomSIPHeaderOptions = async (currentScope) => {
    const res = await axios.get('/TRECustomHeader/Options', {
        headers: {
            'X-RequestScope': currentScope,
        },
    });
    return res.data;
};

export default getCustomSIPHeaderOptions;
